export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7757.18d10eed.jpg";